// Save bytes already in hand to the reader's disk.
//
// A download is not a navigation: the blob exists in memory (a fetched export,
// a client-assembled CSV), so there is nothing to send the tab to and nothing
// to re-authenticate. The object-URL + hidden-anchor dance is the only way a
// browser will accept that.
//
// It lives HERE, rather than being copied again, because `bi` may only import
// `@recruiter/shared` (never another app) and needed it for its per-chart CSV —
// the same reason `funnel-geometry` moved up from the admin console.
//
// This is the intended single home, but it is NOT yet the only copy. `web` uses
// it (`web/src/lib/download.ts` re-exports it and keeps only its own
// `Content-Disposition` parser); four hand-rolled copies remain, and migrating
// them is worth doing for more than tidiness (doctrine 1.10) because three of
// them revoke the object URL SYNCHRONOUSLY after `click()`, which can race the
// browser's own read of it and cancel the save — the race the delayed revoke
// below exists to avoid:
//   - admin/src/pages/explorer-project.tsx           (`saveBlob`, revokes on the
//     next task, so this one is correct — just duplicated)
//   - admin/src/components/insights-prod-testing.tsx (synchronous revoke, and
//     never appends the anchor to the document)
//   - admin-internal/src/pages/quality-ranker-page.tsx        (synchronous revoke)
//   - admin-internal/src/components/admin/project-detail.tsx  (synchronous revoke,
//     no append)
export function downloadBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.rel = "noopener";
  document.body.appendChild(a);
  a.click();
  a.remove();
  // Give the browser a beat to start the download before revoking. Revoking
  // synchronously after click() races the download in Safari and leaves the
  // reader with nothing.
  window.setTimeout(() => URL.revokeObjectURL(url), 10_000);
}
